import React from 'react';
import { IColumnDefinitionMeta } from '../../../../utils/apollo/graphqlSchema';
import KubitTooltip from '../../../../components/KubitTooltip';
import { getColumnDefinitionMetaDisplay } from '../utils';

interface IProps {
  definition: IColumnDefinitionMeta;
}

const DerivedDefinitionMetaDisplay = ({ definition }: IProps) => {
  const { typeText, details } = getColumnDefinitionMetaDisplay(definition);
  return (
    <KubitTooltip noOpenDelay={true} content={<div>{details}</div>}>
      <div>{typeText}</div>
    </KubitTooltip>
  );
};

export default DerivedDefinitionMetaDisplay;
